import config from '../config';
import { ErrorWithLocale, GlobalError } from '../interfaces';
import request, { requestOptions, requestOptionsFormData } from '../utils/request';

const baseUrl = `${config.API_ROOT}/app/conversation`;

type UpdateTemplateResponse = {
  ok: boolean,
  error?: ErrorWithLocale,
}

const ConversationApi = {
  async newConversation({ phoneNumber, message, name, companyId }: { phoneNumber: string, message: string, name?: string, companyId?: string }) {
    const options = requestOptions('POST', { phoneNumber, message, name, companyId }, true);
    const url = `${baseUrl}`;
    const { data, err } : { data: UpdateTemplateResponse, err: GlobalError } = await request(url, options);
    if (err) {
      throw err
    }

    return data;
  },
  async newConversationV2(formData: FormData) {
    const options = requestOptionsFormData(formData, true);
    const url = `${config.API_ROOT}/app/new-conversation`;
    const { data, err } : { data: UpdateTemplateResponse, err: GlobalError } = await request(url, options);
    if (err) {
      throw err
    }

    return data;
  }
}

export default ConversationApi;
